<template>
  <a-card :bordered="false">
    <SignFileShow v-if="signDisabled && !pdfCententShow" :sectionId='sectionId' :type='pdfParams.type'></SignFileShow>
    <div style="margin-bottom: 10px;text-align: center;">
<!--      <a-button v-if="pdfCententShow" v-print="'#pdfCentent'" style="margin-right: 20px;">打印</a-button>-->
      <a-button v-if="pdfCententShow" style="margin-right: 10px" htmlType='button'
                @click='saveOpenTableSignFile' :loading='loading' type='primary'>保存签章文件
      </a-button>
      <SignatureComponent
        v-show="pdfCententShow"
        ref="stamp"
        :pdf-params="pdfParams"
        @checkStampForm="checkStampForm"
        @changeIsStamp="changeIsStamp"
      ></SignatureComponent>
      <SignFileShow-modal ref="modalForm"></SignFileShow-modal>
    </div>

    <div style="margin-bottom: 10px;text-align: center" >
      <!--      <a-button v-show='!pdfCententShow' class="todo" type="primary" :disabled="signDisabled" icon="check-square" @click="signature()">签章</a-button>-->
      <!--      <a-button  v-show='!pdfCententShow && signDisabled' type='primary' @click="signShow" style="margin-left: 10px">签章文件查看</a-button>-->
      <!--      <a-button v-show="pdfCententShow" htmlType="button" @click='reEdit' type="primary" style="margin-right: 10px">重新编辑</a-button>-->
      <!--      <a-button v-show="pdfCententShow" htmlType="button" @click='getSignedPdf' type="primary" style="margin-right: 10px">获取签章文件</a-button>-->
      <SignatureButton
        v-show="!pdfCententShow"
        ref="SignatureButton"
        :pdf-params="pdfParams"
        :stampShowed="pdfCententShow"
        :disabled="signDisabled"
        @sign="sign"
        @signShow="signShow"
      ></SignatureButton>
      <!--      <a-button  v-if="!pdfCententShow" v-print="'#pdfCentent'" style="margin-left: 20px;">打印</a-button>-->
    </div>
    <!-- table区域-begin -->
    <div v-show='!pdfCententShow && !signDisabled' id="pdfCentent">
      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
      :pagination="false">
        <template slot="title" slot-scope="currentPageData">
          <div style='width: 100%;text-align: center;font-size: 24px;'>
            <span>{{tenderProjectInfo.tenderProjectName}}（项目名称）{{sectionInfo.bidSectionName}}标段施工监理第一个信封(商务文件)</span><br>
            <span>开标记录表</span>
          </div>
          <div style='width: 100%;text-align: right;font-size: 16px;display: inline-block;'>开标时间：{{openHomeBeginTime}}
          </div>
        </template>
        <template slot="footer" slot-scope="currentPageData">
          <div>
            <b><span
              style='color : red'>投标文件异常情况分析：（若存在信息异常，是否否决投标以评标专家委员会裁决意见为准）</span></b><br>
            <b>(1)递交投标文件信息雷同投标人：</b><span
            v-for='(item,i) in boBidderRepeat.uploadReduplicate'>{{ item.bidderName }},</span><br>
          </div>
        </template>
      </a-table>
      <div style='margin-top: 20px'>
        <div style='width: 50%;font-size: 15px;display: inline-block'>招标人代表：_____________________</div>
        <div style='width: 50%;font-size: 15px;display: inline-block;text-align: right'>记录人：_____________________</div>
      </div>
      <div style='width:100%;font-size: 15px;display: inline-block;margin-top: 20px;text-align: right;'>_________年_______月_______日</div>
    </div>
    <!-- table区域-end -->

<!--    <div>-->
<!--      <iframe v-show="pdfCententShow" ref='signIframe' frameBorder="no" :src="pdfParams.signedPdfUrl" width='100%' height="900" style='border-bottom:1px solid #3D3D3D;'></iframe>-->
<!--    </div>-->

<!--    <stamp v-show='isNeedStamp' :is-stamp='isStamp' ref='stamp' :pdf-params='pdfParams'-->
<!--           @checkStampForm='checkStampForm'-->
<!--           @changeIsStamp='changeIsStamp'></stamp>-->


  </a-card>
</template>

<script>

import {FzisListMixin} from '@/mixins/FzisListMixin'
import {getAction, postAction} from '@api/manage'
import numeral from 'numeral'
import SignFileShowModal from '../modules/SignFileShowModal'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
import SignFileShow from "@views/bobidopen/modules/SignFileShow.vue";
export default {
  name: 'SupervisionFirstEnvelopeOpenTable',
  mixins: [FzisListMixin],
  components: {SignFileShow, WorkChangeStamp, stamp ,SignatureComponent,SignatureButton,SignFileShowModal},
  data() {
    return {
      description: '第一信封开标情况记录表',
      boBidderRepeat: {},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        // {
        //   title: '代表球号',
        //   align: "left",
        //   dataIndex: 'bidderBall',
        //   width: 60,
        // },
        {
          title: '投标人',
          align: "left",
          dataIndex: 'bidderName',
          width: 120,
        },
        {
          title: '投标保证金递交情况',
          width: 80,
          align: "left",
          // dataIndex: 'marginPrice',
          customRender: function(t, r, index) {
            return numeral(r.marginPrice).format('0.00')
          }
        },
        {
          title: '递交投标文件电脑的硬件信息',
          children: [
            {
              title: "MAC地址",
              dataIndex: "uploadMacAddress",
              align: "left",
              width: 120,
            },
            {
              title: "CPU序列号",
              dataIndex: "uploadCpuId",
              align: "left",
              width: 120,
            },
            {
              title: "硬盘序列号",
              dataIndex: "uploadHardDiskSerialNumber",
              align: "left",
              width: 120,
            },
          ],
        },
        {
          title: '投标人信用分申请使用情况',
          children: [
            {
              title: "企业",
              dataIndex: "enterpriseCreditGrade",
              align: "left",
              width: 80,
            },
            {
              title: "总监理工程师",
              dataIndex: "managerCreditGrade",
              align: "left",
              width: 80,
            },
          ],
        },
        {
          title: '备注',
          align: "left",
          dataIndex: '',
          width: 50,
        },
      ],
      url: {
        list: "",
      },
      sectionId : "",
      bidProjectId:"",
      disableMixinCreated: true,
      tenderProjectInfo:{},
      sectionInfo:{},
      sectionInfos: [],
      openHomeBeginTime : "",
      //以下签章-----------
      isNeedStamp: true,
      isStamp: true,
      pdfCententShow: false,
      pdfParams: {
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '',
        sectionId: '',
        type: 'FirstOpenTableStamp',
        typeZh: '开标记录表一签章',
        htmlTitle: '开标记录表一签章',
        fp: '4',
        signType:'1'//1:统一CA，2：工改签章
      },
      signDisabled:false
    }
  },
  created() {
  },
  methods : {
    setBidProjectId(tenderId ,sectionId) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.bidProjectId = tenderId
      this.pdfParams.bidProjectId = tenderId
      this.pdfParams.sectionId = sectionId
      this.sectionId = sectionId;
      this.queryParam.sectionId = sectionId;
      //设置本页面标识，用于redis key记录当前页面签章信息
      this.pdfParams.pageId = this.sectionId + "_FirstOpenTable_" + new Date().getTime();
      this.url.list = "/ebid-ce/tmBidder/queryFirstEnvelopeBidder/" + sectionId;
      this.setButtonStatus()
      this.loadData();
      this.getTenderInfo();
      this.getBoBidderRepeat();
    },
    getBoBidderRepeat() {
      getAction('/ebid-ce/boBidderRepeat/getBoBidderRepeat/' + this.sectionId, {}).then(res => {
        if (res.success) {
          this.boBidderRepeat = res.result;
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getTenderInfo() {
      let that = this;
      getAction("/ebid-ce/tmBidProject/queryById",{id:that.bidProjectId}).then(res=>{
        if(res.success){
          this.tenderProjectInfo = res.result;
          that.getSectionInfo();
          that.getSectionInfos();
          that.getOpenTime();
        }else {

        }
      })
    },
    getSectionInfos() {
      let that = this;
      getAction("/ebid-ce/tmBidSection/queryByBidProjectId",{bidProjectId:that.bidProjectId}).then(res=>{
        if(res.success){
          that.sectionInfos = []
          for (let i = 0; i < res.result.length; i++) {
            that.sectionInfos.push(res.result[i].bidSectionName);
          }
        }else {

        }
      })
    },
    getSectionInfo() {
      let that = this;
      getAction("/ebid-ce/tmBidSection/queryById",{id:that.sectionId}).then(res=>{
        if(res.success){
          this.sectionInfo = res.result;
        }else {

        }
      });
    },
    getOpenTime() {
      getAction("/room/schedule/getListByTmRoomSchedule", {
        bidProjectId: this.bidProjectId,
        roomType: "1"
      }).then(res => {
        if (res.success) {
          this.openHomeBeginTime = res.result[0].beginTime;
        } else {
          this.$message.warning("开标时间获取失败");
        }
      })
    },
    //-----------以下为签章--------------------
    sign(type) {
      this.pdfParams.signType = type;
      this.pdfCententShow = true
      this.$refs.stamp.checkStamp()
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    //重新编辑
    reEdit(){
      this.pdfParams.pageId="";
      this.pdfParams.signedPdfUrl="";
      this.pdfCententShow = false;
      this.$refs.stamp.pdfUrl=null;
    },
    // getSignedPdf(){
    //   let that = this;
    //   that.$confirm({
    //     title: '确认信息',
    //     content: '请确认是否已经完成签章，未完成则先完成签章，完成则点击确认获取签章文件！',
    //     onOk() {
    //       that.$refs.stamp.getPdfUrl();
    //     },
    //     onCancel(){
    //     },
    //   })
    // },
    changeIsStamp(val) {
      let that = this
      this.pdfCententShow = val;
      if(!val){
        that.setButtonStatus()
      }
    },
    setButtonStatus() {
      let that = this
      getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
        sectionId: that.sectionId,
      }).then((res) => {
        if (res.success) {
          if(res.result.isCheckOpenTable==1){
            that.signDisabled = true
          }
        }
      })
    },
    checkStampForm(callback) {
      callback(true);
    },
    saveOpenTableSignFile() {
      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先签章')
        return
      }
      let that = this
      that.loading = true
      let params = {}
      params.pdfUrl = that.$refs.stamp.getPdfUrl()
      params.type = that.pdfParams.type
      params.typeZh = that.pdfParams.typeZh
      params.bidProjectId = that.pdfParams.bidProjectId
      postAction('/ebid-ce/boOpenStatus/saveOpenTableSignFile/' + that.sectionId, params).then(res => {
        if (res.success) {
          that.$message.success(res.result)
          that.signDisabled = true
          that.pdfCententShow = true
        } else {
          that.$message.error(res.message)
        }
      }).catch(() => {
        that.$message.error('操作失败，请重试！')
      }).finally(() => {
        that.loading = false
      })
    },
  }
}
</script>

<style scoped>

</style>